import React from "react";
import styled from "styled-components";

function AddBtn({ style, text, onClick }) {
  return (
    <>
      <AddBtnWrapper style={{ ...style }} onClick={onClick}>
        {text ?? "추가하기"}
      </AddBtnWrapper>
    </>
  );
}

export default AddBtn;

const AddBtnWrapper = styled.button.attrs((props) => {})`
  display: flex;
  height: 42px;
  align-items: center;
  justify-content: center;
  padding: 10px 14px;
  border-radius: 23px;
  background: #262c31;
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.048px;
  color: #fff;
  cursor: pointer;
`;
